export default __webpack_public_path__ + "static/media/metaphorically-2.1d761e36.jpg";